var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{staticClass:"card",attrs:{"title":"个人/团队数据看板"}},[_c('time-bar',{ref:"timeTeam",on:{"change":_vm.getData}}),_c('div',{ref:"userData",staticStyle:{"height":"400px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }